

const TRANSLATIONS_NL_NL = {
    "email_otp.back":"Terug",
    "email_otp.enter_email_text":"Voer hieronder je e-mailadres in om een unieke code te ontvangen",
    "email_otp.send_verification_link":"Verificatiecode verzenden",
    "email_otp.resend_otp_with_timer":"Code opnieuw verzenden over",
    "email_otp.text":"We hebben een 6-cijferige verificatiecode naar [email] gestuurd. Voer de code hieronder in",
    "email_otp.verify":"Verifiëren",
    "reset_password.set_password":"Je wachtwoord instellen",
    "sign_in.or":"of",
    "sign_in.continue_with":"Of ga door met",
    "sign_in.continue_with_email":"Of ga door met je e-mailadres",
    "sign_in.create_without_password":"Account aanmaken zonder wachtwoord",
    "sign_in.create_with_otp":"Account aanmaken met een eenmalige toegangscode",
    "sign_in.login_with_otp":"Inloggen met een eenmalige toegangscode",
    "sign_in.login_without_password":"Inloggen zonder wachtwoord",
    "sign_in.tooltip_text":"Je ontvangt een tijdelijke unieke verificatiecode via e-mail om toegang te krijgen tot je account.",
    "sign_up.tooltip_text":"Je ontvangt een tijdelijke unieke verificatiecode via e-mail om een account aan te maken.",
    "sign_in.password_updated":"Je wachtwoord is bijgewerkt.",
    "sign_up.create_an_account":"Maak een account aan",
    "email_otp.resend_otp":"OTP opnieuw verzenden",
    "sign_up.email_address":"E-mailadres",
    "sign_up.password":"Wachtwoord",
    "sign_in.create_account" : "Maak een account aan",
    "sign_in.title": "Aanmelden",
    "sign_in.forgot_password" : "Uw wachtwoord vergeten?",
    "reset_password.resend_email": "E-mail opnieuw versturen",
    "reset_password.sent_title": "E-mail is verstuurd!",
    "reset_password.rcvResetLink": "Voer hieronder uw e-mailadres in en we sturen u een link voor het opnieuw instellen van uw wachtwoord.",
    "reset_password.submit": "Verzenden",
    "reset_password.back_to_login": "Terug naar inloggen",
    "reset_password.create_new_password": "Maak een nieuw wachtwoord aan om in te loggen op uw account.",
    "forgot_password.emailSent": "Als er een account bestaat voor [], dan wordt er een e-mail verstuurd met een link om je wachtwoord te herstellen. Niets ontvangen? Vraag hieronder een nieuwe e-mail aan.",
    "gdpr.continue": "Doorgaan",
    "validation.password_validation_heading": "Het wachtwoord moet het volgende bevatten:",
    "validation.password_length_ui": "Minimaal 8 tekens",
    "validation.password_upper_case_ui": "Een hoofdletter",
    "validation.password_lower_case_ui": "Een kleine letter",
    "validation.password_number_ui": "Een cijfer",
    "validation.password_symbol_ui": "Een speciaal teken",
    "verify_otp.customer_service_center_link": "s/klantenservice",
    "activate_user.verification_successful.message": "Gefeliciteerd! Je account is geactiveerd.",
    "activate_user.already_verified.message" : "Welkom terug! Je account is al geverifieerd.",

    // Errors Translation
    "sign_in.mandatory_field_error": "Vul alle verplichte velden in voordat je verdergaat.",
    "sign_in.invalid_email_error": "Voer het e-mailadres in de juiste indeling in, bijvoorbeeld naam@domein.com",
    "sign_in.invalid_credentials_error": "Je hebt een ongeldige gebruikersnaam of wachtwoord ingevoerd. Probeer het opnieuw.",
    "sign_in.generic_error": "Er is iets misgegaan. Probeer het opnieuw.",
    "sign_in.account_unverified_error": "Je account is nog niet geactiveerd. Kijk of je de activeringslink hebt ontvangen via e-mail of klik op 'Wachtwoord vergeten' om de toegang tot je account te resetten.",
    "sign_in.max_attempt_error": "Maximum aantal pogingen bereikt. Probeer het over een tijdje opnieuw.",
    "sign_in.social_signin_error": "Inloggen via social media (Google/Facebook/Apple) mislukt. Probeer het opnieuw of gebruik een andere inlogmethode",
    "sign_in.social_signin_email_not_present_error": "Inloggen mislukt. Probeer het opnieuw of gebruik een andere inlogmethode.",
    "sign_in.guest_user_signin_error": "Zo te zien heb je al een account met dit e-mailadres. Klik op 'Uw wachtwoord vergeten?' om de toegang tot je account te herstellen.",

    "sign_up.mandatory_field_error": "Vul alle verplichte velden in voordat je verdergaat.",
    "sign_up.invalid_email_error": "Voer een geldig e-mailadres in, bijvoorbeeld naam@domein.com",
    "sign_up.password_length_error": "Het wachtwoord moet minimaal 8 tekens lang zijn.",
    "sign_up.email_already_exist_error": "Dit e-mailadres bestaat al. Gebruik een ander emailadres.",
    "sign_up.generic_error": "Er is iets misgegaan. Probeer het opnieuw.",
    "sign_up.password_policy_error": "Het wachtwoord moet het volgende bevatten: een cijfer, een speciaal teken [!#$%&'*+-/=?^_`{|}~.@], kleine letters en een hoofdletter.",
    "sign_up.common_password_error": "Het wachtwoord mag niet hetzelfde zijn als je e-mailadres",

    "forgot_password.mandatory_field_error": "Vul alle verplichte velden in voordat je verdergaat.",
    "forgot_password.invalid_email_error": "Voer het e-mailadres in de juiste indeling in, bijvoorbeeld naam@domein.com",
    "forgot_password.generic_error": "Er is iets misgegaan. Probeer het opnieuw.",

    "reset_password.mandatory_field_error": "Vul alle verplichte velden in voordat je verdergaat.",
    "reset_password.password_history_error": "Wachtwoord moet verschillen van je vorige vijf wachtwoorden.",
    "reset_password.password_length_error": "Het wachtwoord moet minimaal 8 tekens lang zijn.",
    "reset_password.password_policy_error": "Het wachtwoord moet het volgende bevatten: een cijfer, een speciaal teken [!#$%&'*+-/=?^_`{|}~.@], kleine letters en een hoofdletter.",
    "reset_password.common_password_error": "Het wachtwoord mag niet hetzelfde zijn als je e-mailadres",
    "reset_password.generic_error": "Er is iets misgegaan. Probeer het opnieuw.",

    "email_otp.email_required_error": "Voer je e-mailadres in om door te gaan",
    "email_otp.invalid_email_error": "Voer een geldig e-mailadres in, bijvoorbeeld naam@domein.com",
    "email_otp.generic_error": "Er is iets misgegaan. Probeer het over een tijdje opnieuw",
    "email_otp.invalid_otp_error": "De OTP-/verificatiecode die je hebt ingevoerd is niet geldig. Probeer het opnieuw.",
    "email_otp.resend_otp_error": "Kan OTP niet opnieuw sturen. Probeer het over een tijdje opnieuw",
    "email_otp.verify_otp_error": "Er is iets misgegaan. Probeer de OTP-verificatie over een tijdje opnieuw",
    "email_otp.verify_otp_limit_exceed_error": "De ingevoerde OTP is ongeldig. Klik op 'OTP opnieuw verzenden' voor een nieuwe",
    "email_otp.max_attempt_reached_error": "Maximum aantal pogingen bereikt. Probeer het over een tijdje opnieuw.",
    "email_otp.brute_force_error_part_1": "Je account is tijdelijk vergrendeld vanwege meerdere mislukte inlogpogingen. Probeer het later opnieuw of neem ",
    "email_otp.brute_force_error_part_2": "contact op met ons Helpcentrum",
    "email_otp.brute_force_error_part_3": " voor hulp.",
    "form.gdprconsent": "Door in te loggen, bevestig je dat je akkoord gaat met onze",
    "form.termsCondition": "Algemene voorwaarden",

    //Page Titles
    "sign_in.page_title": "Aanmelden | Pens.com",
    "sign_up.page_title": "Aanmelden | Pens.com",
    "forgot-password.page_title": "Wachtwoord vergeten | Pens.com",
    "reset-password.page_title": "Wachtwoord opnieuw instellen | Pens.com",
    "sign-in.password_icon_aria_label_blured": "Blured Show password",
    "sign-in.password_icon_aria_label": "Show password",
    "sign-in.password_icon_aria_label_hidden": "Hide password",
    "sign-in.tooltip_icon_aria_label": "More Info",
    "email_otp.otp_digit_aria_label": "Please enter the code",
};
export default TRANSLATIONS_NL_NL;